const colors = {
  lightPrimary: '#7bd1ff',
  darkPrimary: '#545454',
  lightSecondary: '#e4f5ff',
  darkBackgroundText: '#fff',
  lightBackgroundText: '#000',

  darkBlack: '#545454',
  black: '#79766d',
  lightBlack: '#989898',
  darkGray: '#B2B2B2',
  gray: '#DBDBDB',
  lightGray: '#F9F7F6',
  red: '#D64532',
};

export default colors;
